var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoPetit = function SvgHospitalinfoPetit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M13.5 16h-4v2h4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M14 15H9v1h5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M14 28H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v7.99c0 .56-.45 1.01-1 1.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M14 22.5H9v3h5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M23 12h-5v12h5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M22 23.99h-3v3h3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M21 3.99h-1v5h1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M21.5 8.99h-2v3h2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M24 26.99h-7v1h7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M20 15.62h-2v.75h2zM20 17.62h-2v.75h2zM20 19.62h-2v.75h2z"
  })));
};
export default SvgHospitalinfoPetit;